function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5 23.622c-2.666-2.11-8.697-6.431-15.151-8.008.008 2.879-2.878 6.478-8.744 6.416-5.874-.07-8.666-3.733-8.596-6.612-6.486 1.428-12.618 5.616-15.332 7.663a1.961 1.961 0 00-.447 2.658c1.42 2.102 4.008 5.953 5.639 8.517a1.964 1.964 0 002.964.408c1.96-1.757 2.918-2.667 2.918-2.667l-3.153 11.529a4.675 4.675 0 002.494 5.45c2.572 1.224 6.776 2.51 13.168 2.58 6.399.071 10.634-1.113 13.23-2.281a4.676 4.676 0 002.627-5.38l-2.902-11.82s.934 1.067 2.847 2.91a1.969 1.969 0 002.996-.313c1.686-2.525 4.352-6.306 5.82-8.376a1.955 1.955 0 00-.377-2.674z",
  fill: "#F5F1E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.534 30.774a2.76 2.76 0 100-5.521 2.76 2.76 0 000 5.521z",
  fill: "#5E4537"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.534 25.253a2.76 2.76 0 00-.031 5.521h.031a2.76 2.76 0 00.031-5.521h-.03zM37.448 38.585a2.76 2.76 0 100-5.52 2.76 2.76 0 000 5.52z",
  fill: "#5E4537"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M37.448 33.072a2.76 2.76 0 00-.031 5.521h.03a2.76 2.76 0 00.031-5.521h-.03zM73.382 43.753a2.57 2.57 0 012.565 2.565v25.966a2.57 2.57 0 01-2.565 2.565H47.416a2.57 2.57 0 01-2.564-2.565V46.318a2.57 2.57 0 012.564-2.565h25.966zm0-5.842H47.416a8.408 8.408 0 00-8.407 8.407v25.966a8.408 8.408 0 008.407 8.407h25.966a8.408 8.408 0 008.408-8.407V46.318c-.008-4.643-3.765-8.407-8.408-8.407z",
  fill: "#5E4537"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M72.99 75.884H47.808c-2.203 0-4-1.788-4-4V46.703c0-2.203 1.789-4 4-4H72.99c2.204 0 4 1.789 4 4v25.183a4.006 4.006 0 01-4 4z",
  fill: "#F8A6B1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M53.274 52.13v.156h-.157v-.157h.157zm4.04-5.844h-8.235c-.996 0-1.804.808-1.804 1.804v8.235c0 .996.808 1.804 1.804 1.804h8.234c.996 0 1.804-.808 1.804-1.804V48.09c0-.996-.808-1.804-1.804-1.804z",
  fill: "#5E4537"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M56.482 55.768h-6.557a.29.29 0 01-.29-.29v-6.556a.29.29 0 01.29-.29h6.557a.29.29 0 01.29.29v6.556c0 .157-.133.29-.29.29z",
  fill: "#F8A6B1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M54.278 50.364h-2.164a.757.757 0 00-.761.761v2.165c0 .423.337.76.76.76h2.165c.424 0 .761-.337.761-.76v-2.165a.756.756 0 00-.76-.76zM53.274 65.98v.156h-.157v-.157h.157zm4.04-5.844h-8.235c-.996 0-1.804.808-1.804 1.804v8.235c0 .996.808 1.804 1.804 1.804h8.234c.996 0 1.804-.808 1.804-1.804V61.94c0-.996-.808-1.803-1.804-1.803z",
  fill: "#5E4537"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M56.482 69.618h-6.557a.29.29 0 01-.29-.29v-6.556a.29.29 0 01.29-.29h6.557a.29.29 0 01.29.29v6.556c0 .157-.133.29-.29.29z",
  fill: "#F8A6B1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M54.278 64.215h-2.164a.757.757 0 00-.761.76v2.165c0 .423.337.76.76.76h2.165c.424 0 .761-.337.761-.76v-2.165a.756.756 0 00-.76-.76zM67.289 52.129v.157h-.157v-.157h.157zm4.047-5.843H63.1c-.996 0-1.804.808-1.804 1.804v8.235c0 .996.808 1.804 1.804 1.804h8.235c.996 0 1.803-.808 1.803-1.804V48.09a1.814 1.814 0 00-1.803-1.804z",
  fill: "#5E4537"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M70.496 55.768H63.94a.29.29 0 01-.29-.29v-6.556a.29.29 0 01.29-.29h6.556a.29.29 0 01.29.29v6.556c0 .157-.133.29-.29.29z",
  fill: "#F8A6B1"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M68.292 50.364h-2.164a.756.756 0 00-.76.761v2.165c0 .423.336.76.76.76h2.164c.424 0 .761-.337.761-.76v-2.165a.756.756 0 00-.76-.76z",
  fill: "#5E4537"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  fill: "#5E4537"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.254 60.136h-2.957v2.957h2.957v-2.957z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.254 60.136h-2.957v2.957h2.957v-2.957zM64.254 66.003h-2.957v2.956h2.957v-2.956z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.254 66.003h-2.957v2.956h2.957v-2.956zM67.21 68.96h-2.956v2.956h2.956v-2.957z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.21 68.96h-2.956v2.956h2.956v-2.957zM70.167 60.136H67.21v2.957h2.957v-2.957z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.175 60.136H67.21v2.957h2.965v-2.957zM67.21 63.093h-2.956v2.957h2.956v-2.957z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.21 63.093h-2.956v2.965h2.956v-2.965zM73.131 63.093h-2.956v2.957h2.956v-2.957z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.131 63.093h-2.956v2.965h2.956v-2.965zM70.167 66.057H67.21v2.957h2.957v-2.957z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.175 66.057H67.21v2.957h2.965v-2.957zM73.131 69.014h-2.956v2.957h2.956v-2.957z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.131 69.014h-2.956v2.957h2.956v-2.957z"
}));

var SvgAppiconMydesign = function SvgAppiconMydesign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppiconMydesign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appicon-mydesign.646f867a.svg";
export { ForwardRef as ReactComponent };